<div class="dialog">
  <div class="dialog__title">
    <div class="dialog__header">
      <h5>
        Provide compliance {{ data?.selectedProducts?.length > 1 ? 'statements' : 'statement' }} for
        {{ data?.selectedRsl?.name ?? '' }}
      </h5>
    </div>
    <mat-icon class="dialog__close" role="button" aria-label="Close" mat-dialog-close>close</mat-icon>
  </div>

  <div class="dialog__content" mat-dialog-content>
    <section class="dialog__section">
      <div class="section__title">
        <mds-icon [width]="22" [height]="22" [key]="mdsIcon.PRODUCTS"></mds-icon>

        <div>
          @if (data.selectedProducts.length > 1) {
            <h5>Selected Products ({{ selectedProductsOverrides.rowData.length }})</h5>
          }

          @if (data.selectedProducts.length === 1) {
            <h5>{{ data.selectedProducts[0].name }}</h5>
            @if (data.selectedProducts[0].prop_MPN || data.selectedProducts[0].prop_PN) {
              <p>
                @if (data.selectedProducts[0].prop_MPN) {
                  MPN: {{ data.selectedProducts[0].prop_MPN }}
                }
                @if (data.selectedProducts[0].prop_MPN || data.selectedProducts[0].prop_PN) {
                  &nbsp;|&nbsp;
                }
                @if (data.selectedProducts[0].prop_PN) {
                  PN: {{ data.selectedProducts[0].prop_PN }}
                }
              </p>
            }
          }
        </div>
      </div>
      @if (selectedProductsOverrides) {
        <mds-grid
          [overrides]="selectedProductsOverrides"
          [sizeColumnsToFit]="true"
          [minHeight]="'200'"
          themeClass="ag-theme-material"
        ></mds-grid>
      }
    </section>
    <section class="dialog__section">
      @if (showWarning) {
        <div class="section__warning">
          <mds-icon [pathColors]="['#FFA76B']" [key]="mdsIcon.WARNING" [height]="22" [width]="19"></mds-icon>
          <p>Changing the statement field will override your previous settings for all selected products</p>
        </div>
      }
      <form [formGroup]="statementForm">
        <formly-form [fields]="statementTypes" [form]="statementForm"></formly-form>
        @if (!isSCIPInfoProvided) {
          <div class="section__warning scip-required-message">
            <mds-icon [pathColors]="['#FFA76B']" [key]="mdsIcon.WARNING" [height]="22" [width]="19"></mds-icon>
            <span>For Non-Compliant Products: please provide SCIP number for the Product</span>
          </div>
        }
      </form>
      @if (
        currentStatement === statementStatus.COMPLIANT_WITH_EXEMPTION ||
        currentStatement === statementStatus.NON_COMPLIANT
      ) {
        <div class="section__exemptions">
          <div class="section__exemptions__header">
            <mat-label>
              {{
                currentStatement === statementStatus.COMPLIANT_WITH_EXEMPTION ? 'Exemptions' : 'Cause of Non-Compliance'
              }}
            </mat-label>
            @if (data.editable) {
              <mds-button
                type="secondary"
                [icon]="mdsIcon.PLUS_DARK"
                [isIconLeft]="true"
                (click)="addNewRow()"
                class="section__exemptions__add-row"
              >
                Add New Row
              </mds-button>
            }
          </div>
          <mds-grid
            [overrides]="exemptionOverrides"
            (gridReady)="onGridReady($event)"
            [minHeight]="200"
            [sizeColumnsToFit]="true"
          ></mds-grid>
          @if (!isSCIPInfoProvided) {
            <div class="section__warning">
              <mds-icon [pathColors]="['#FFA76B']" [key]="mdsIcon.WARNING" [height]="22" [width]="19"></mds-icon>
              <span>
                For Non-Compliant Substances: please provide either SCIP Material Category or SCIP Mixture Category
              </span>
            </div>
          }
        </div>
      }
    </section>
    <section class="dialog__section">
      @if (data.attachments.length || showAttachments) {
        <div class="section__title attachments-title">
          <h5>Attachments</h5>
          @if (data?.selectedProducts?.length === 1) {
            <p>New documents will be attached to each selected product. All previous documents remain intact.</p>
          }
          @if (data?.selectedProducts?.length > 1) {
            <p>New documents will be added to each selected product, replacing all existing ones.</p>
          }
        </div>
      }
      <div class="attachments">
        @if (data.attachments.length) {
          <div class="attachments--previously-uploaded">
            @for (attachment of data.attachments; track attachment; let i = $index) {
              <ng-container
                *ngTemplateOutlet="attachmentItem; context: { attachment, index: i, isLocalUpload: false }"
              ></ng-container>
            }
          </div>
        }
        @if (showAttachments) {
          <div class="attachments--new">
            <mat-label class="attachments__title">
              Supporting Document(s)
              @if (isAttachmentRequired) {
                <span class="required">*</span>
              }
            </mat-label>
            <div class="attachments__content">
              <div class="attachments__upload-button" (drop)="onFilesDrop($event)" (dragover)="$event.preventDefault()">
                <mds-icon [key]="mdsIcon.UPLOAD_FILE" [width]="42" [height]="46"></mds-icon>
                <div class="attachments__drop-location">
                  Drop your file here or
                  <a (click)="fileUpload.click()">browse</a>
                </div>
                <div class="attachments__file-types">Supports all file types</div>
                <input type="file" style="visibility: hidden" #fileUpload (change)="onFilesUploaded($event)" />
              </div>
              <div class="attachments__uploaded">
                @for (attachment of attachments; track attachment; let i = $index) {
                  <ng-container
                    *ngTemplateOutlet="attachmentItem; context: { attachment, index: i, isLocalUpload: true }"
                  ></ng-container>
                }
              </div>
            </div>
          </div>
        }
      </div>
      <app-compliance-questionnaire-comments
        (commentChanged)="changeComment($event)"
        [data]="data"
        [showSendOption]="data?.selectedProducts?.length === 1"
      ></app-compliance-questionnaire-comments>
    </section>
  </div>

  <div class="dialog__actions" mat-dialog-actions align="end">
    <mds-button type="secondary" (click)="onCancel()">Cancel</mds-button>
    <mds-button [disabled]="disabled" class="actions__save ml-20" type="primary" (click)="!disabled && onSave()">
      Save
    </mds-button>
  </div>
</div>

<ng-template #confirmationActions>
  <mds-button type="secondary" (click)="confirmationDialog.close(false)">Cancel</mds-button>
  <mds-button type="primary" (click)="confirmationDialog.close(true)">Override</mds-button>
</ng-template>
<ng-template #attachmentItem let-attachment="attachment" let-index="index" let-isLocalUpload="isLocalUpload">
  <div class="uploaded">
    <div class="uploaded__tile" [tabIndex]="0">
      <div class="uploaded__icon">
        <mds-icon [key]="mdsIcon.ATTACHMENT" [width]="20" [height]="20"></mds-icon>
      </div>
      <div class="uploaded__content">
        <div class="uploaded__title">{{ attachment?.name ?? '' }}</div>
        <div class="uploaded__attached">Attached to: Product</div>
      </div>
    </div>
    @if (!isLocalUpload) {
      <div
        class="uploaded__download"
        [matTooltip]="'Download'"
        (click)="onAttachmentDownload(index)"
        aria-label="Download"
        [tabIndex]="0"
      >
        <mds-icon [key]="mdsIcon.DOWNLOAD" [width]="16" [height]="16" [pathColors]="['#42454B']"></mds-icon>
      </div>
    }
    @if (data.editable) {
      <div
        class="uploaded__remove"
        [matTooltip]="'Delete'"
        (click)="onAttachmentRemove(index, isLocalUpload)"
        aria-label="Delete"
        [tabIndex]="0"
      >
        <mds-icon [key]="mdsIcon.TRASH" [width]="22" [height]="22"></mds-icon>
      </div>
    }
  </div>
</ng-template>
